import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e159be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "arrow"
}
const _hoisted_2 = { class: "message whitespace-nowrap" }
const _hoisted_3 = {
  key: 0,
  class: "whitespace-nowrap"
}

interface Props {
  message?: string|string[];
  hideArrow?: boolean;
  light?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    message: { default: '' },
    hideArrow: { type: Boolean },
    light: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tooltip", {light: __props.light}]),
    ref: "tooltipRef"
  }, [
    (!__props.hideArrow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        (typeof __props.message === 'string')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.message), 1))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.message, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "whitespace-nowrap",
                key: i
              }, _toDisplayString(item), 1))
            }), 128))
      ])
    ])
  ], 2))
}
}

})